<script setup lang="ts">
import type { CarouselItemProps } from './interface';

import { cn } from '@/utils';

const props = withDefaults(defineProps<CarouselItemProps>(), { as: 'div' });
</script>

<template>
	<Component
		:is="props.as"
		role="group"
		aria-roledescription="slide"
		:class="cn('min-w-0 shrink-0 grow-0 basis-full', props.class)"
	>
		<slot></slot>
	</Component>
</template>
